import { OccurrenceCounter } from '@/domain/termine/components';
import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { Field } from '@e2n/ui';

export function OccurrenceCountFormField({
  className,
}: {
  className?: string;
}) {
  const { form } = useCreateTermineFormContext();
  return (
    <form.Field name="occurrenceCount">
      {(field) => (
        <Field className="flex flex-row w-1/3 gap-1">
          <div className={className}>
            <OccurrenceCounter
              value={field.state.value || 1}
              onChange={field.handleChange}
            />
          </div>
        </Field>
      )}
    </form.Field>
  );
}
